document.addEventListener("DOMContentLoaded", function () {
	let id = ".splide-testimonials-medias-slider";
	let splideElem = document.querySelector(id);
	if (splideElem) {
		new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: false,
			perPage: 1,
			breakpoints: {
				768: {
					arrows: false,
					pagination: true,
				},
			},
		}).mount();
	}
});
